import { render, staticRenderFns } from "./index-quiz.vue?vue&type=template&id=22d0c1c7&scoped=true&"
import script from "./index-quiz.vue?vue&type=script&lang=js&"
export * from "./index-quiz.vue?vue&type=script&lang=js&"
import style0 from "./index-quiz.vue?vue&type=style&index=0&id=22d0c1c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d0c1c7",
  null
  
)

export default component.exports